<template>
    <el-header style="height: 90px;">
        <div class="logo">
            <img src="../assets/images/logo.png"/>
        </div>
        <div class="menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
                <el-menu-item index="/introduce">公司简介</el-menu-item>
                <el-menu-item index="/product">核心产品</el-menu-item>
                <el-menu-item index="/case">合作案例</el-menu-item>
                <el-menu-item index="/company">公司资质</el-menu-item>
                <el-menu-item index="/joinus">加入我们</el-menu-item>
            </el-menu>
        </div>
        <div class="info">
            <div class="text">
                <div class="item" style="border-right: solid 1px #ffffff;"><img
                    src="../assets/images/telephone.png"/><span>023-63529000</span></div>
                <div class="item"><img src="../assets/images/email.png"/><span>hr@meitq.com</span></div>
            </div>
        </div>
    </el-header>
</template>

<script>
export default {
    name: "header-meitq",
    data() {
        return {
            activeIndex: '/introduce'
        }
    },
    watch: {
        '$route' (to, form) {
            if(to.path === '/prodetail'){
                this.activeIndex = '/product'
            } else {
                this.activeIndex = to.path;
            }
        }
    },
    created() {
        if(this.$route.path === '/prodetail'){
            this.activeIndex = '/product'
        } else {
            this.activeIndex = this.$route.path;
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
    .el-header {
        display: flex;
        .logo {
            width: 320px;
            margin-top: 24px;
        }
        .menu {
            flex: 1;
            .el-menu {
                margin-top: 15px;
                background: transparent;
            }
            .el-menu.el-menu--horizontal {
                border-bottom: none;
                > .el-menu-item {
                    height: 50px;
                    line-height: 50px;
                    color: #ffffff;
                    font-size: 16px;
                }
                > .el-menu-item:hover {
                    background-color: transparent;
                    border-bottom: 2px solid #ffffff;
                }
                > .el-menu-item.is-active {
                    background-color: transparent;
                    border-bottom: 2px solid #ffffff;
                }
            }
        }
        .info {
            .text {
                height: 30px;
                margin-top: 25px;
                padding: 5px 0;
                box-sizing: border-box;
                border: solid 1px #ffffff87;
                border-radius: 2px;
                color: #ffffff;
                font-size: 14px;
                .item {
                    display: inline-block;
                    height: 20px;
                    padding: 0 8px;
                    box-sizing: border-box;
                    span {
                        padding: 0 5px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/headerMei.vue